export default "__VITE_ASSET__BN0CUHoK__"